export default __webpack_public_path__ + "static/media/ELEKIPO.abc82e7d.png";